import React from 'react';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
export function FinalCTA() {
  return <section className="border-t-8 border-brand-orange bg-brand-graphite px-4 py-6 text-white" data-id="element-42" data-mp="c70y9baodhp3">
      <div className="mx-auto max-w-3xl text-center" data-id="element-43" data-mp="84xkuh4g4316">
        <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-amber sm:text-sm" data-id="element-44" data-mp="87a1mqygw7cn">
          One Last Chance
        </p>
        <p className="mx-auto mb-2 max-w-2xl text-sm font-normal leading-snug text-white/85 sm:text-base" data-id="element-45" data-mp="h4u05s4y3pjk">
          The Smart Home industry continues to grow every year. Instead of spending months trying to
          learn through scattered content, start with one complete professional system that guides
          you step by step from beginner to installer. Learn. Install. Build real projects. Start
          offering Smart Home installation services with confidence.
        </p>
        <a href={CHECKOUT_URL} className="mb-3 block cursor-pointer" aria-label="Buy Smart Home Installer Pro" data-id="element-46" data-mp="2c5g788ku96x0">
          <img src={PRODUCT_IMG} alt="Smart Home Installer Pro 6-in-1 system box set" className="mx-auto w-full max-w-[220px] object-contain drop-shadow-2xl transition-transform duration-200 hover:scale-[1.02]" data-id="element-47" data-mp="2h4sugufmgg04" />
        </a>
        <div className="mb-3 rounded-2xl border border-white/15 bg-white/10 p-3.5 shadow-lg" data-id="element-48" data-mp="2v427xmcg0w0e">
          <p className="mb-1 font-display text-xs font-bold uppercase leading-snug tracking-wide sm:text-base" data-id="element-49" data-mp="302c4o1dtg4o4">
            SMART HOME INSTALLER PRO™ — Complete 6-in-1 Installation &amp; Business System + 5
            Premium Bonuses
          </p>
          <p className="text-base sm:text-lg" data-id="element-50" data-mp="39rvpvdp04am5">
            <span className="text-white/60 line-through" data-id="element-51" data-mp="3errthbtse016">Regular Price: $97</span>{' '}
            | <span className="font-display font-extrabold text-brand-amber" data-id="element-52" data-mp="3it3a4ruonax8">TODAY ONLY: $27 USD</span>
          </p>
        </div>
        <CTAButton href={CHECKOUT_URL} className="mx-auto mb-2 max-w-md" data-id="element-53" data-mp="1jnk104omporl">
          🚀 YES! I WANT MY SMART HOME INSTALLER PRO™ SYSTEM
        </CTAButton>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-white/90 sm:text-sm" data-id="element-54" data-mp="1en5tcnqxwgu3">
          <div className="flex items-center gap-1" data-id="element-55" data-mp="1npez70b9jm15">
            <ZapIcon className="h-4 w-4 text-brand-amber" data-id="element-56" data-mp="1nnu51bsv253t" />
            <span data-id="element-57" data-mp="22drz28dh1p0x">Immediate Access • Delivered Instantly by Email</span>
          </div>
          <span className="hidden text-white/30 sm:inline" data-id="element-58" data-mp="1xgje600xv6vz">•</span>
          <div className="flex items-center gap-1" data-id="element-59" data-mp="1xi4c7zmgp7yl">
            <StarIcon className="h-4 w-4 fill-brand-amber text-brand-amber" data-id="element-60" data-mp="2be807b6qsk2m" />
            <span data-id="element-61" data-mp="27do2o6i9befy">⭐⭐⭐⭐⭐ 4.9/5 — Verified Student Reviews</span>
          </div>
          <span className="hidden text-white/30 sm:inline" data-id="element-62" data-mp="h18dky3y2plu">•</span>
          <div className="flex items-center gap-1" data-id="element-63" data-mp="h1rtk9a1b3x8">
            <ShieldCheckIcon className="h-4 w-4 text-brand-amber" data-id="element-64" data-mp="d0ohzyz0ru1t" />
            <span data-id="element-65" data-mp="2vybdfso81r9">🛡️ 7-Day Money-Back Guarantee</span>
          </div>
        </div>
      </div>
    </section>;
}